import React from 'react';

const Subtitle: React.FC = ({ children }) => (
  <h5 className="mt-20 text-14 leading-24 font-normal text-gray-400 text-center">{children}</h5>
);

export default Subtitle;
